module.exports = __webpack_public_path__ + "static/img/function1.a3b7b8a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/function1.gif
// module id = YL01
// module chunks = 0